'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { MdKeyboardArrowRight } from 'react-icons/md';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function Therapies({ categories }: { categories: CategoriesEntity[] }) {
  return (
    <div
      className={cn(
        'custom-container',
        'relative z-10 grid w-full grid-cols-1 gap-2 sm:grid-cols-3 md:gap-4 lg:gap-6',
      )}
    >
      {categories.map((category, index) => (
        <Link
          key={index}
          href={ROUTES.CATEGORY({ slug: category?.slug ?? '#' })}
          className="col-span-1 flex w-full items-center justify-between gap-4 rounded-[16px] bg-[#F2EDE6] p-4 transition-all hover:bg-opacity-90 md:p-5 lg:p-6"
        >
          <div className="flex items-center justify-start gap-4 md:gap-5 lg:gap-6">
            <Image
              src={category?.image?.url ?? '/images/placeholder.png'}
              alt={resolveImageAlt(category?.image, category?.name)}
              width={50}
              height={50}
              className="max-h-[50px] min-h-[50px] min-w-[50px] max-w-[50px] overflow-hidden rounded-full object-cover object-center"
              sizes="50px"
            />
            <p className="whitespace-nowrap font-semibold tracking-tight text-foreground">
              {category.name}
            </p>
          </div>
          <MdKeyboardArrowRight className="max-h-6 min-h-6 min-w-6 max-w-6 text-foreground" />
        </Link>
      ))}
    </div>
  );
}
